import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Select from '../common/form/select';
import SelectDefault from '../common/form/selectDefault';

import { setModoTela, initForm } from './usuarioActions';
import labelAndInputMask from '../common/form/labelAndInputMask';
import ClienteUtils from '../common/utils/ClienteUtils';

class UsuarioForm extends Component {

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='nome'
								component={LabelAndInput}
								label='Nome *' placeholder='Informe o Nome'
								cols='12 12 12 12'
								readOnly={(!this.props.formularioValues.id || this.props.configuracao) ? null : 'readOnly'} />

							<Field
								name='email'
								component={LabelAndInput}
								label='E-mail *'
								placeholder='Informe o E-mail'
								cols='12 12 12 12'
								readOnly={this.props.formularioValues.id ? 'readOnly' : readOnly} />

							{!this.props.configuracao &&
							<Field
								name='senha'
								component={LabelAndInput}
								type="password"
								label='Senha *'
								placeholder='Informe a Senha'
								cols='12 12 12 12'
								readOnly={readOnly} />}

							{(!this.props.formularioValues.id || this.props.configuracao) &&
							<Select
								name='ids_perfis'
								options={this.props.listaPerfil}
								label='Perfis de Acesso'
								cols='12 12 12 12'
								placeholder='Selecione'
								readOnly={readOnly}
								multiple
								value={this.props.formularioValues.ids_perfis}
								onChange={values => {
									this.props.initForm({
										...this.props.formularioValues,
										ids_perfis: values.map(item => item.value)
									});
								}} />}

							<Field
								name='id_vendedor'
								component={LabelAndInput}
								label='ID do Vendedor'
								placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
							
							<Field
								name='codigo_vendedor'
								component={LabelAndInput}
								label='Código do Vendedor'
								placeholder='Informe'
								cols='12 6 4 3'
								readOnly={readOnly} />
						</Row>						
						
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

UsuarioForm = reduxForm({form: 'usuarioForm', destroyOnUnmount: false})(UsuarioForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('usuarioForm')(state),
	registro: state.usuario.registro,
	listaPerfil: state.usuarioPerfil.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(UsuarioForm);
